import { SOURCES } from '@/shared/constants';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type OrderType = {
  type?: 'delivery' | 'self-pickup';
  [key: string]: any;
};

type SessionState = {
  branch: { menu_id?: string } | null;
  source: string;
  selected_product_id: string;
  geolocation: 'accepted' | 'rejected' | 'pending';
  order_type: OrderType | null;
  setSelectedProduct: (id: string) => void;
  acceptGeoL: () => void;
  rejectGeoL: () => void;
  resetGeoL: () => void;
  setOrderType: (order_type: OrderType | null) => void;
  setBranch: (branch: { menu_id?: string } | null) => void;
};

export const useSessionStore = create<
  SessionState,
  [['zustand/persist', SessionState]]
>(
  persist(
    (set) => ({
      branch: null,
      source: SOURCES.porto_teg,
      selected_product_id: '',
      geolocation: 'pending',
      order_type: null,
      setSelectedProduct: (id: string) => {
        set(() => ({
          selected_product_id: id,
        }));
      },
      acceptGeoL: () => {
        set(() => ({
          geolocation: 'accepted',
        }));
      },
      rejectGeoL: () => {
        set(() => ({
          geolocation: 'rejected',
        }));
      },
      resetGeoL: () => {
        set(() => ({
          geolocation: 'pending',
        }));
      },
      setOrderType: (order_type: OrderType | null) => {
        set(() => ({
          order_type,
        }));
      },
      setBranch: (branch: { menu_id?: string } | null) => {
        set(() => ({
          branch,
        }));
      },
    }),
    {
      name: 'session-storage', // sessionStorage key
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
